/**
 * supplier模块路由
 * Created by dgw on 2018/09/28.
 */
import _import from './_import_development'

export  default {
  path: '/supplier',
  name: 'supplier',
  component: _import("Home"),
  meta: {permission: false},
  children: [
    // 供应商
    { path: 'SupplierType',component:_import("supplier/SupplierType"),name:'供应商分类'},
    { path: 'supplierList',component:_import("supplier/SupplierList"),name:'供应商列表'},
    { path: 'supplierAdd',component:_import("supplier/SupplierAdd"),name:'供应商编辑'},
    // 采购
    { path: 'purchasePrice',component:_import("supplier/PurchasePrice"),name:'采购价表'},
    { path: 'purchaseMakePrice',component:_import("supplier/PurchaseMakePrice"),name:'采购定价'},
    { path: 'purchaseMakePriceAdd',component:_import("supplier/PurchaseMakePriceAdd"),name:'采购定价编辑'},

    //库存
    { path: 'StockInList',component:_import("supplier/StockInList"),name:'入库单'},
    { path: 'StockInAdd',component:_import("supplier/StockInAdd"),name:'入库单编辑'},
    { path: 'StockInInfo',component:_import("supplier/StockInInfo"),name:'入库单详情'},

    { path: 'StockOutList',component:_import("supplier/StockOutList"),name:'出库单'},
    { path: 'StockOutAdd',component:_import("supplier/StockOutAdd"),name:'出库单编辑'},
    { path: 'StockOutInfo',component:_import("supplier/StockOutInfo"),name:'出库单详情'},

    { path: 'StockCheckList',component:_import("supplier/StockCheckList"),name:'盘点单'},
    { path: 'StockCheckAdd',component:_import("supplier/StockCheckAdd"),name:'盘点单编辑'},
    { path: 'StockCheckInfo',component:_import("supplier/StockCheckInfo"),name:'盘点单详情'},

    { path: 'StockNumList',component:_import("supplier/StockNumList"),name:'现存量查询'},

  ]
}




// WEBPACK FOOTER //
// ./src/router/supplier.js